export default __webpack_public_path__ + "static/media/mainslide3.631fd581.jpg";